module.exports = __webpack_public_path__ + "img/Settings.267731c1.svg";